import ExchangeLittlePage from 'pages/Dashboard/Widgets/Exchange/ExchangeLittle';
import React from 'react';
import useRequest from '../../../../hooks/use-request';
import { EXCHANGE_DATA } from '../../../../utils/api';

const ExchangeLittle = (props) => {
    const [handleRequest, status] = useRequest()
    const [data, setData] = React.useState()

    React.useEffect(() => {
        if (props.demo) {
            return
        }
        handleRequest("get", EXCHANGE_DATA(props.symbol, props.base), {}, {}, (data, status) => {
            if (status === "Done") {
                setData(data);
            } else if (status === "Error") {
                console.error(data);
            }
        }, true)
    }, [])

    const handleReload = () => {
        handleRequest("get", EXCHANGE_DATA(props.symbol, props.base), {}, {}, (data, status) => {
            if (status === "Done") {
                setData(data);
            } else if (status === "Error") {
                console.error(data);
            }
        }, true)
    }

    return (
        <ExchangeLittlePage
            {...props}
            status={status}
            data={data}
            handleReload={handleReload}
        />
    );
};

export default ExchangeLittle;